export default class App {

    constructor() {
        this.controllers = {};
        this.actions = {};
    }

    registerController(name, controller) {
        this.controllers[name] = controller;
        controller.setApp(this);
        controller.onRegistered();
    }

    getController(name) {
        return this.controllers[name];
    }

    registerAction(name, handler) {
        this.actions[name] = handler;
    }

    callAction(actionName, args) {
        this.actions[actionName](args);
    }

    createView(view, model) {
        view.setApp(this);
        return view.createView(model);
    }

    renderView(view, model) {
        view.setApp(this);
    }

}